import React, { FC, useCallback } from 'react'
import { useFormContext } from 'react-hook-form'
import { AsyncSelect, InputGroup, Button, Icon } from '@wmgtech/legato'

import { IArtist } from 'shared/interfaces'
import { ProjectCreateContainer, ProjectCreateHelper } from 'modules/ProjectCreate/components'
import { helperInfo } from 'modules/ProjectCreate/constants'
import { SearchItem } from 'components/SearchItem'
import { useField } from 'components/Form'
import createSubtitle from 'shared/utils/createArtistInfoSubtitle'

import { IArtistSelectionProps } from './ArtistSelection.props'
import './ArtistSelection.scss'

const ArtistSelection: FC<IArtistSelectionProps> = ({ onSelectArtist, searchArtists, options, artistLoading, onCreate }) => {
  const { control } = useFormContext()

  const { validation, field } = useField('searchedName', control)

  const handleSelect = useCallback<(artist?: IArtist) => void>(
    (artist) => {
      if (typeof artist !== 'undefined') {
        onSelectArtist(artist)
      }
    },
  [onSelectArtist],
  )

  return (
    <ProjectCreateContainer className="artist-selection">
      <div className="artist-selection__section">
        <h3 className="artist-selection__title">Select Artist</h3>
        <InputGroup
          label="Artist"
          labelProps={{ icon: 'asterisk' }}
          validation={{
            ...validation,
            pending: artistLoading
          }}
        >
          <AsyncSelect
            list={options}
            size="lg"
            value={field.value}
            getTitle={({ name }) => name}
            getKey={({ id }) => id}
            name="searchedName"
            onSearch={searchArtists}
            onSelect={handleSelect}
            isLoading={artistLoading}
            placeholder="Start typing Artist name..."
            getElement={({ name, gcdm_info }) => <SearchItem title={name} subtitle={createSubtitle(gcdm_info?.genre, gcdm_info?.country, gcdm_info?.company)} />}
            renderFooter={() => (
              <div className="lgt-list-bottom">
                <Button
                  secondaryIcon={<Icon prefix="fas" name="circle-plus" />}
                  containerStyle="link"
                  colorType="secondary-black"
                  htmlType="button"
                  onClick={() => onCreate(field.value)}
                >Create New Artist</Button>
              </div>
            )}
          />
        </InputGroup>
      </div>
      <div className="artist-selection__section">
        <ProjectCreateHelper>
          <p>{helperInfo.addArtist}</p>
        </ProjectCreateHelper>
      </div>
    </ProjectCreateContainer>
  )
}

export default ArtistSelection
